<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span>Sales</span>
                    <a>Campaign</a>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                    <button class="btn btn-new-primary btn-wide px-6 mr-4" @click="showFilters()"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
                    <button class="btn btn-new-primary btn-wide px-6 mr-4"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px"> Export to Excel</button>
                    <button class="btn btn-new-danger btn-wide px-6 mr-4" v-if="userPermissions.campaigns.permitted_actions.delete" :style="selectedCampaigns.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="selectedCampaigns.length ? $modal.show('deleteCampaign') : ''" :disabled="disableDelete">- Delete</button>
                    <button class="btn btn-new-green btn-wide px-6" v-if="userPermissions.campaigns.permitted_actions.create" @click="$router.push('/campaign/sms/createCampaignSms/')">+ Create Campaign</button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <div class="blue_header pointer">
                        <span>List View</span>
                    </div>
                    <div class="blue_header_triangle pointer"></div>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex" style="flex-grow: 1">
                        <i class="icon icon-magnify icondefault" style="border-radius: 20px 0px 0px 20px; padding: 6px 16px; height: 2.7em;"></i>
                        <input class="w-100 placeholder-text" type="text" placeholder="Search by Campaign Name" v-model="search_campaign_key" v-debounce:500ms="searchCampaign" debounce-events="input" style="border-radius: 0px 20px 20px 0px; padding-left: 10px; height: 2.9em;">
                    </div>
                </div>
            </div>
            <div class="table-block overflow-x-auto pt-10" style="background-color:#fff;border-top-right-radius:5px">
                <table class="team-list-table w-100">
                    <thead>
                        <tr>
                            <th class="w-1" v-if="userPermissions.campaigns.permitted_actions.delete" >
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" @change="selectALL()" :checked="this.selectedCampaigns.length == this.campaigns.length && this.selectedCampaigns.length"/>
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </th>
                            <th v-if="userPermissions.campaigns.permitted_actions.view"></th>
                            <th v-if="userPermissions.campaigns.permitted_actions.edit"></th>
                            <th>CAMPAIGN NAME</th>
                            <th>INDUSTRY TYPE</th>
                            <th>START DATE</th>
                            <th>END DATE</th>
                            <th>STATUS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="w-100" v-if="ajaxCallInProgress">
                            <td colspan="9">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress && campaigns.length == 0" class="text-center font-weight-bold">
                            <td colspan="8">No Campaigns Found</td>
                        </tr>
                        <tr v-else v-for="(campaign, index) in campaigns" :key="index">
                            <td class="w-1" v-if="userPermissions.campaigns.permitted_actions.delete">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" @change="selectOne(campaign._id)" :checked="selectedCampaigns.includes(campaign._id)" />
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td v-if="userPermissions.campaigns.permitted_actions.view">
                                <div class="pointer">
                                    <el-tooltip class="item" effect="dark" content="View" placement="top">
                                        <button class="pointer btn-icon pt-3" style="padding:0px!important;" @click="viewCampaign(campaign._id)">
                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" height="15px;">
                                        </button>
                                    </el-tooltip>
                                </div>
                            </td>
                            <td v-if="userPermissions.campaigns.permitted_actions.edit">
                                <div class="pointer" v-if="campaign.status != 'approved'">
                                    <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                        <button class="pointer btn-icon pt-3" style="padding:0px!important;" @click="editCampaign(campaign._id)">
                                            <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                        </button>
                                    </el-tooltip>
                                </div>
                            </td>
                            <td class="text-capitalize new-blue-text pointer text-truncate cell-width" v-if="campaign.status == 'approved'" @click="campaignAnalytics(campaign._id, campaign.start_date, campaign.category_id)">
                                {{ campaign.name || "-" }}
                            </td>
                            <td class="text-capitalize new-blue-text text-truncate cell-width" v-else>
                                {{ campaign.name || "-" }}
                            </td>
                            <td class="text-truncate cell-width" :title="campaign.industry_type">{{ campaign.industry_type || "-" }}</td>
                            <td>{{ campaign.start_date || "-" }}</td>
                            <td>{{ campaign.end_date || "-" }}</td>
                            <td>
                                <button style="text-transform: capitalize; width: 110px !important;" class="btn btn-smm text-white btn-default btn-width"
                                    :class="{
                                    'btn-pending':campaign.status == 'pending',
                                    'btn-approved':campaign.status == 'approved',
                                    'btn-rejected':campaign.status == 'rejected'}">
                                        {{ campaign.status[0].toUpperCase() + campaign.status.substring(1) }}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <button @click="firstPage()" class="mt-1 pointer pagination-list">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pointer pagination-list">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
        <div v-if="display_filters" class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
            <filter-data @hideFilters="hideFilters"  :showfilterData="showfilterData" @appliedFilter="appliedFilter"></filter-data>
        </div>
        <delete-campaign modal_name="deleteCampaign" @deleteCampaigns="deleteCampaigns" @cancelDelete="selectedCampaigns = []"></delete-campaign>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import campaignList from "../../mixins/campaign.js"
import DeleteCampaign from "../../alertModals/DeleteCampaign";
const FilterData = () => import('./FilterData')
import { SweetModal } from 'sweet-modal-vue';
export default {
    data(){
        return{
            disableDelete: true,
            success_msg:"",
            warning_msg:"",
            ajaxCallInProgress: false,
            campaigns: [],
            selectedCampaigns: [],
            display_filters: false,
            hide_filters: false,
            showfilterData: {
                campaign_name: [],
                industry_type: [],
                start_date: "",
                end_date: "",
                template: [],
                status: []
            },
            filterData: {
                campaign_name: [],
                industry_type: [],
                start_date: "",
                end_date: "",
                template: [],
                status: []
            },
            temp_total: 0,
            skip: 0,
            limit: 10,
            skip_temp: 0,
            total: 0,
            search_campaign_key: ''
        }
    },
    mixins: [campaignList],
    components: {
        DeleteCampaign,
        FilterData,
        HalfCircleSpinner,
        SweetModal
    },
    methods:{
        async getCampaigns() {
            this.ajaxCallInProgress = true
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: "",
                    type: "sms",
                    "filter_json": {
                        "campaign_ids": this.filterData.campaign_name,
                        "end_date": this.filterData.end_date,
                        "industry_type": this.filterData.industry_type,
                        "start_date": this.filterData.start_date,
                        "status": this.filterData.status,
                        "template_type": this.filterData.template
                    },
                };
                let response = await this.getCampaignList(params)
                this.total = response.count
                this.campaigns = response.response
            }
            catch (error) {
            }
            this.ajaxCallInProgress = false
        },
        async searchCampaign(){
            this.ajaxCallInProgress = true
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: this.search_campaign_key,
                    type: "sms",
                    "filter_json": {
                        "campaign_ids": this.filterData.campaign_name,
                        "end_date": this.filterData.end_date,
                        "industry_type": this.filterData.industry_type,
                        "start_date": this.filterData.start_date,
                        "status": this.filterData.status,
                        "template_type": this.filterData.template
                    },
                };
                let response = await this.getCampaignList(params)
                this.total = response.count
                this.campaigns = response.response
            }
            catch (error) {
            }
            this.ajaxCallInProgress = false
        },
        firstPage(){
            this.selectedCampaigns = []
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.getCampaigns()
        },
        nextPage() {
            this.selectedCampaigns = []
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getCampaigns()
        },
        previousPage() {
            this.selectedCampaigns = []
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getCampaigns()
        },
        lastPage() {
            this.selectedCampaigns = []
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getCampaigns()
        },
        viewCampaign(id) {
            this.$router.push('/campaign/sms/approveSmsCampaign/'+ id);
        },
        editCampaign(id) {
            this.$router.push('/campaign/sms/createCampaignSms/'+ id);
        },
        selectALL(){
            if(this.selectedCampaigns.length == this.campaigns.length && this.selectedCampaigns.length){
                this.selectedCampaigns = []
                this.disableDelete = true
            } else {
                this.campaigns.forEach(el => {
                    this.selectedCampaigns.push(el._id)
                });
                this.disableDelete = false
            }
        },
        selectOne(id) {
            if (this.selectedCampaigns.includes(id)) {
                this.selectedCampaigns = this.selectedCampaigns.filter(x => x != id);
                if(this.selectedCampaigns == ""){
                    this.disableDelete = true
                }
            } else {
                this.selectedCampaigns.push(id);
                this.disableDelete = false
            }
        },
        async deleteCampaigns(){
            try{
                let params = {
                    ids: this.selectedCampaigns
                }
                let response = await this.deleteCampaignsByID(params)
                //this.getCampaigns();
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$modal.hide("deleteCampaign");
                        this.selectedCampaigns = [];
                        this.getCampaigns();
                        this.$refs.success_modal.close();
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }
            catch(reason){

            }
        },
        async campaignAnalytics(id, date, category_id){
            this.$router.push(`/campaign/sms/campaignSmsDetails?category_id=${category_id}&start_date=${date}&campaign_id=${id}`)
        },
        showFilters(){
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters(){
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
        },
        appliedFilter(data){
            this.filterData = {
                campaign_name: data.value.created_campaign_name,
                industry_type: data.value.created_industry_type,
                start_date: data.value.created_start_date,
                end_date: data.value.created_end_date,
                template: data.value.created_template,
                status: data.value.created_status
            }
            this.showfilterData = {
                campaign_name: data.value1.created_campaign_name,
                industry_type: data.value1.created_industry_type,
                start_date: data.value1.created_start_date,
                end_date: data.value1.created_end_date,
                template: data.value1.created_template,
                status: data.value1.created_status
            }
            this.getCampaigns();
        }
    },
    mounted(){
        this.getCampaigns();
    },
    computed:{
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        }
    },
}
</script>
<style scoped>
    .scm-filters{
        height: fit-content !important;
        padding-bottom: 20px !important;
        overflow: auto !important;
    }
    .team-list-table thead tr th {
        background: #005dae;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .btn-pending{
        background: #E4A045 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .btn-approved{
        background: #078A63 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .btn-rejected{
        background: #E64646 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }

    .overflow-x-auto{
        overflow-x: auto !important
    }
    .cell-width{
        max-width: 500px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Campaign/Sms/campaignSmsListView.vue